
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/first-post",
      function () {
        return require("private-next-pages/posts/first-post.js");
      }
    ]);
  